/**
 * internal dependencies
 */
import { COMMON_FORM_ELEMENTS } from "./pin-pool-types";
import { ICardGroupInsertUpdate } from '../../../../../models/cardgroup.interface';

/**
 * Display the Card Group Name and Customer Name in the Pin Pool form.
 * 
 * @param data cardGroup data
 * @return void
 */
export const displayInfo = (data: ICardGroupInsertUpdate) => {
  const { ceCustomerName, ceCardGroupName } = COMMON_FORM_ELEMENTS;
  const { customerId, customerName, cardGroupName, cardGroupId } = data;

  ceCustomerName.value = customerName ?? '';
  ceCustomerName.dataset.customerId = customerId.toString() ?? '';
  ceCardGroupName.value = cardGroupName ?? '';
  ceCardGroupName.dataset.cardGroupId = cardGroupId?.toString() ?? '';
};